import { ref } from "vue";

export type Modal = {
    open: () => void;
    close: () => void;
};

export function useModal() {
    const modal = ref<{ open: () => void; close: () => void } | null>(null);

    function open() {
        if (modal.value) {
            modal.value.open();
        }
    }

    function close() {
        if (modal.value) {
            modal.value.close();
        }
    }

    return {
        modal,
        open,
        close,
    };
}
